import { type TypographyVariantsOptions } from '@mui/material';

export const typography: TypographyVariantsOptions = {
  fontFamily: '"Geist", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
  giant: {
    fontSize: '64px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '72px',
  },

  header: {
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '40px',
  },

  // Figma coupons: Geist Regular, 32/40, zero letter spacing (unnamed style).
  title_regular_32_40: {
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '40px',
    letterSpacing: 0,
  },
  // Figma coupon amount/status: Geist Bold, 24/32, zero letter spacing.
  title_bold_24_32: {
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '32px',
    letterSpacing: 0,
  },
  // Figma game table headings: Geist Regular, 12/24, zero letter spacing.
  description_12_24: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: 0,
  },

  title_accent_18_32: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '32px',
  },
  title_accent_18_18: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '18px',
  },
  title: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '32px',
  },
  body_14_24: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  },
  body_14_20: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
  },
  subtitle_14_24: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '24px',
  },
  subtitle_14_20: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '20px',
  },
  subtitle_alt: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '16px',
    textTransform: 'uppercase',
  },
  small_description: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
  button: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '24px',
    textTransform: 'uppercase',
  },
};
